import React from "react";
const leaves = [{
  cx: 15,
  cy: 40,
  r: -35
}, {
  cx: 25,
  cy: 44,
  r: 55
}, {
  cx: 25,
  cy: 27,
  r: -35
}, {
  cx: 36,
  cy: 31,
  r: 55
}, {
  cx: 37,
  cy: 15,
  r: -35
}, {
  cx: 47,
  cy: 17,
  r: 55
}];
export function LeafSprig({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 60 60" className={className} aria-hidden="true" data-id="element-83" data-mp="1ekutapc4jfjd">
      <path d="M6 56 C 20 44, 34 30, 54 6" stroke="#3F8A30" strokeWidth="2.5" fill="none" strokeLinecap="round" data-id="element-84" data-mp="1en7klt3rv293" />
      {leaves.map((l, i) => <ellipse key={i} cx={l.cx} cy={l.cy} rx="4.5" ry="9" fill={i % 2 ? "#6DB54F" : "#4E9B3A"} transform={`rotate(${l.r} ${l.cx} ${l.cy})`} data-id="element-85" data-mp="1ohg1fjjfx6rf" data-mpi={i} />)}
    </svg>;
}